import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { TIKTOK_URL } from "@/content/copy";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0.001, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.9, ease, delay }}
    >
      {children}
    </M>
  );
};

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`ph-eyebrow ${className}`}>
    <span aria-hidden="true" className="ph-eyebrow-dot" />
    {children}
  </p>
);

export const TikTokButton = ({ children, testId, variant = "solid", className = "" }) => (
  <a
    href={TIKTOK_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    className={`ph-btn ${variant === "solid" ? "ph-btn-solid" : "ph-btn-ghost"} ${className}`}
  >
    <span>{children}</span>
    <span className="ph-btn-icon" aria-hidden="true">
      <ArrowUpRight size={18} strokeWidth={2.2} />
    </span>
    <span className="sr-only"> (opens TikTok in a new tab)</span>
  </a>
);

export const Owl = ({ className = "", alt = "Philosophiles owl logo: a cream owl with a heart-shaped face and a letter P in its wing", ...rest }) => (
  <picture>
    <source srcSet="/brand/owl.webp" type="image/webp" />
    <img src="/brand/owl.png" alt={alt} className={className} draggable="false" {...rest} />
  </picture>
);
